import PropTypes from 'prop-types';

import { Box, Grid, useMediaQuery } from '@mui/material';
import SectionTabsList from 'components/SectionTabsList/SectionTabsList';
import HeaderAndMenu from 'components/HeaderAndMenu/HeaderAndMenu';
import DesignerDashboardWrapper from 'components/Wrappers/DashboardWrapper/DesignerDashboardWrapper/DesignerDashboardWrapper';
import { StyledTabsSectionContainer } from '../TabsSectionStyles';

const DesignerTabSectionsWrapper = ({
  title,
  headerMenuOptions,
  children,
  breadcrumbs,
  activeTab,
  chatbox,
  options,
  handleSectionClick,
  collapse,
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <Box>
      <DesignerDashboardWrapper activeTab={activeTab} breadcrumbs={breadcrumbs} collapse={collapse}>
        <HeaderAndMenu title={title} menuOptions={headerMenuOptions} />
        <Grid container direction={isMobile ? 'column' : 'row'}>
          <StyledTabsSectionContainer md={2} item>
            <SectionTabsList
              onClick={handleSectionClick}
              options={options}
              orientation={isMobile ? 'horizontal' : 'vertical'}
            />
          </StyledTabsSectionContainer>
          <Grid md={10} mb={2} pt={'0 !important'} item sx={{ paddingLeft: { sm: 0, md: 2 } }}>
            {children}
          </Grid>
        </Grid>
      </DesignerDashboardWrapper>
      {chatbox}
    </Box>
  );
};

DesignerTabSectionsWrapper.propTypes = {
  title: PropTypes.string,
  headerMenuOptions: PropTypes.object,
  breadcrumbs: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  activeTab: PropTypes.string,
  chatbox: PropTypes.node,
  options: PropTypes.object,
  handleSectionClick: PropTypes.func,
};

export default DesignerTabSectionsWrapper;
